/**
 * DEV-2684 — açık sekme büronun yetki modu değişimini yanıttan öğrenir.
 *
 * Kiracı API yanıtları `X-Yetki-Modu: yeni|eski` taşır (YetkiKapisiMiddleware). Büro modu düğmeyle,
 * destek komutuyla ya da başka bir yöneticiyle değişince store'daki /ben özeti bayat kalır ve mod
 * değişimi 403 üretmeyebilir. Başlık store'daki `yetki.mod`'dan farklıysa /ben zorla tazelenir;
 * rota kapısı (router `store.watch`) bulunulan sayfayı yeni kullanıcıyla yeniden değerlendirir.
 *
 * Dövme koruması: /ben yanıtının kendisi karşılaştırılmaz; aynı uyumsuzluk sürerse (tazeleme
 * başarısız) yalnız ilk tetikleme zorlar, sonrakiler benTazele'nin aralık sınırına tabidir.
 */
import {store} from "@/store";
import {benTazele} from "@/plugins/benTazele";
import {benIstegiMi} from "@/utils/benIstegi";

/** axios yanıt başlıkları küçük harfle gelir. */
export const YETKI_MODU_BASLIGI = "x-yetki-modu";

let zorlananMod: string | null = null;

export function yetkiModuBasliginiDenetle(yanit: any): void {
    try {
        const mod = yanit && yanit.headers ? yanit.headers[YETKI_MODU_BASLIGI] : undefined;
        if (mod !== "yeni" && mod !== "eski") {
            return;
        }
        if (benIstegiMi(yanit.config && yanit.config.url)) {
            return;
        }
        const user = store.state.user;
        const mevcut = user && user.yetki ? user.yetki.mod : undefined;
        if (mevcut !== "yeni" && mevcut !== "eski") {
            return;
        }
        if (mod === mevcut) {
            zorlananMod = null;
            return;
        }
        const force = zorlananMod !== mod;
        zorlananMod = mod;
        benTazele({force});
    } catch (e) {
        // Başlık yalnız ek bilgidir: denetim hiçbir yanıtı bozmaz.
    }
}
